import * as React from 'react';
import Avatar from '@sdk/components/avatar/Avatar';
import GroupsSvg from '@sdk/assets/svg/Icons/32/groups-gray.svg';

import PositionsSvg from '@web/assets/svg/Icons/32/position-gray.svg';
import LocationsSvg from '@web/assets/svg/Icons/32/location-gray.svg';
import { MentionPersona } from '@web/richText/types';

const iconMap = {
  position: PositionsSvg,
  location: LocationsSvg,
  group: GroupsSvg,
  everyone: GroupsSvg,
};

type IconProps = {
  persona: MentionPersona;
};

export const ItemIcon: React.FC<React.PropsWithChildren<IconProps>> = ({ persona }) => {
  const type = persona.type;
  if (type === 'user') {
    return <Avatar noBorder user={persona} />;
  }

  const Component = iconMap[type];
  return Component ? <Component /> : null;
};
